import React, { useState } from 'react';
import PropTypes from 'prop-types';

import './ConfirmPrompt.scss';

const ConfirmPrompt = props => {
  const {
    isSingleLine,
    hideInput,
    onCancel,
    onCustom,
    preloaded,
    placeholder,
    onSubmit,
    header,
    subheader,
    rows,
    selectOptions,
    selectPlaceholder,
    submitBtnDisplay,
    cancelBtnDisplay,
    customBtnDisplay,
    requireInput,
    maxLength
  } = props;
  const [inputVal, setInputVal] = useState(preloaded || '');
  const [selectVal, setSelectVal] = useState('');
  const clip = value => (maxLength ? value.slice(0, maxLength) : value);
  const isSubmitDisabled = Boolean((selectOptions && !selectVal) || (requireInput && !inputVal.trim()));
  return (
    <div
      className='confirm-prompt-outer-container react-confirm-alert-body'
      role={hideInput ? 'alertdialog' : undefined}
      aria-label={hideInput ? header : undefined}
    >
      <h1 className='header'>{header}</h1>
      <div className='subheader'>{subheader}</div>
      {selectOptions && (
        <select
          autoFocus
          value={selectVal}
          aria-label={selectPlaceholder || 'Select an option'}
          onChange={({ target }) => setSelectVal(target.value)}
        >
          <option value=''>{selectPlaceholder || 'Select an option'}</option>
          {selectOptions.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      )}
      {!hideInput &&
        (isSingleLine ? (
          <input
            type='text'
            placeholder={placeholder || ''}
            maxLength={maxLength}
            onChange={({ target }) => setInputVal(clip(target.value))}
            value={inputVal}
          />
        ) : (
          <textarea
            type='text'
            rows={rows || 6}
            placeholder={placeholder || ''}
            maxLength={maxLength}
            onChange={({ target }) => setInputVal(clip(target.value))}
            value={inputVal}
          />
        ))}
      <div className='react-confirm-alert-button-group'>
        <button className='cancel-btn' autoFocus={hideInput} onClick={() => onCancel()}>
          {cancelBtnDisplay || 'Cancel'}
        </button>
        {customBtnDisplay && (
          <button className='cancel-btn' disabled={isSubmitDisabled} onClick={() => onCustom(inputVal, selectVal)}>
            {customBtnDisplay}
          </button>
        )}
        <button disabled={isSubmitDisabled} onClick={() => onSubmit(inputVal, selectVal)}>
          {submitBtnDisplay || 'Submit'}
        </button>
      </div>
    </div>
  );
};

ConfirmPrompt.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCustom: PropTypes.func,
  header: PropTypes.string.isRequired,
  subheader: PropTypes.string,
  placeholder: PropTypes.string,
  rows: PropTypes.number,
  selectOptions: PropTypes.arrayOf(PropTypes.shape({ value: PropTypes.string.isRequired, label: PropTypes.string.isRequired })),
  selectPlaceholder: PropTypes.string,
  customBtnDisplay: PropTypes.string,
  submitBtnDisplay: PropTypes.string,
  cancelBtnDisplay: PropTypes.string,
  isSingleLine: PropTypes.bool,
  hideInput: PropTypes.bool,
  requireInput: PropTypes.bool,
  maxLength: PropTypes.number
};

export default ConfirmPrompt;
